"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEND_BASKET_UI = exports.SEND_BASKET_MODAL_FIELDS = exports.GENERATE_PREVIEW_UI = void 0;
var SEND_BASKET_MODAL_FIELDS = exports.SEND_BASKET_MODAL_FIELDS = {
  EMAIL: 'emails',
  TYPE: 'type',
  TITLE: 'title',
  LOCALE: 'locale'
};
var SEND_BASKET_UI = exports.SEND_BASKET_UI = 'SEND_BASKET_UI';
var GENERATE_PREVIEW_UI = exports.GENERATE_PREVIEW_UI = 'GENERATE_PREVIEW_UI';